import React, {Component} from 'react'
import {getWeekLinks, getReplaceStudentPlanIdentifier} from '../../services/reservoir'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'

const mapStateToProps = ({
  courses: { selectedCourseCode, data },
  course: { selectedCourse },
  sliders,
  currentUser
}) => {

  const courseSliders = sliders[selectedCourseCode]

  const {sliderItems = []} = courseSliders.data.find(slider => {
    return slider.id === courseSliders.defaultSlider
  })

  const selectedSliderItem = sliderItems.find(sliderItem => sliderItem.id === courseSliders.selectedSlide)

  return {
    courseId: selectedCourseCode,
    admissionCategory: selectedCourse.admissionCategory,
    college: selectedCourse.orgUnit,
    defaultLocation: selectedCourse.locationCd,
    selectedSlide: courseSliders.selectedSlide,
    activeCalendarType: selectedSliderItem.teachingPeriod ? selectedSliderItem.teachingPeriod.calendarType : false,
    associatedWeek: selectedSliderItem.associatedWeek.id,
    userRole: currentUser.data['role'],
    userId: currentUser.data['vuId'],
    versionNo: selectedCourse.versionNumber,
    attemptNo: selectedCourse.attemptNumber

  } 
}

class WeekLinks extends Component {
  constructor(props) {
    super(props)

    this.state = {
      weekLinks: [],
    }
  }

  componentDidMount() {
    this.updateWeekLinks()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.courseId !== this.props.courseId ||
      prevProps.selectedSlide !== this.props.selectedSlide
    ) {
      this.updateWeekLinks()
    }
  }

  updateWeekLinks = () => {
    this.setState({
      weekLinks: [],
    })

    getWeekLinks(
      this.props.associatedWeek,
      this.props.admissionCategory,
      this.props.college,
      this.props.activeCalendarType,
      this.props.defaultLocation,
      this.props.userRole
      
    ).then(weekLinks => {
      this.setState({
        weekLinks: weekLinks.filter(weekLink => !!weekLink.attributes.field_week_link).map(weekLink => ({
          id: weekLink.id,
          link: weekLink.attributes.field_week_link.uri,
          title: weekLink.attributes.field_week_link.title,
        }))
      })
    })
  }
  
 

    
  render() {
    return (
      <div className='todo-list'>
        {this.state.weekLinks.length === 0 ? null : (
          <ul>
            {this.state.weekLinks.map(weekLink => (
              <li key={weekLink.id}><a href={
                ((weekLink.link).includes('$STDPLNID_MYVU$') ?
                        getReplaceStudentPlanIdentifier(weekLink.link, this.props.userId, this.props.courseId, this.props.versionNo, this.props.attemptNo)
                       : weekLink.link)
                }>{weekLink.title}</a></li>
            ))}
          </ul>
        )}
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(WeekLinks))
